import { render, staticRenderFns } from "./Patents.vue?vue&type=template&id=3f007df4&scoped=true&lang=html&"
import script from "./Patents.vue?vue&type=script&lang=js&"
export * from "./Patents.vue?vue&type=script&lang=js&"
import style0 from "./Patents.vue?vue&type=style&index=0&id=3f007df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f007df4",
  null
  
)

component.options.__file = "Patents.vue"
export default component.exports